module.exports = {"440402001":"翠香街道办","440402002":"梅华街道办","440402003":"前山街道办","440402004":"吉大街道办","440402005":"拱北街道办","440402006":"香湾街道办","440402007":"狮山街道办","440402008":"湾仔街道办","440402100":"唐家湾镇","440402102":"南屏镇","440402104":"横琴镇","440402105":"桂山镇","440402106":"万山镇","440402107":"担杆镇","440402401":"南屏科技园","440402402":"保税区","440402403":"前山商贸物流中心","440402404":"洪湾商贸物流中心","440402406":"金鼎工业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440402.json
// module id = 1801
// module chunks = 0